import { CellContext } from "@tanstack/react-table";
import { Link } from "react-router";

import { Brand } from "../../../types/brand";
import { Prompt } from "../../../types/prompts";
import { TableData, ScoreDataByEntity } from "../../Table/types";

export const renderCellValue = (info: CellContext<TableData, unknown>) => info.getValue();

export function buildColumns(selectBrands: Brand[]) {
  return [
    {
      id: "prompts",
      accessorKey: "prompts",
      header: "Prompts",
      cell: renderCellValue,
    },
    ...selectBrands.map((brand, brandIndex) => {
      const groupId = `brand_group_${brandIndex}`;
      return {
        id: groupId,
        accessorKey: groupId,
        header: brand.name,
        meta: { brandId: brand.id },
        cell: renderCellValue,
      };
    }),
  ];
}

export function buildData(params: {
  prompts: Prompt[];
  promptsDailyBaseRoute: string;
  selectBrands: Brand[];
  scoreModel: ScoreDataByEntity;
  isScoreLoading: boolean;
}): TableData[] {
  const { prompts, promptsDailyBaseRoute, selectBrands, scoreModel, isScoreLoading } = params;

  const rows: TableData[] = [];

  for (const prompt of prompts) {
    const row: TableData = {
      prompts: {
        label: <Link to={`${promptsDailyBaseRoute}${prompt.id}`}>{prompt.content}</Link>,
      },
    };

    for (let brandIndex = 0; brandIndex < selectBrands.length; brandIndex++) {
      const brand = selectBrands[brandIndex];
      const groupId = `brand_group_${brandIndex}`;
      const score = scoreModel?.[String(brand.id)]?.[String(prompt.id)];

      row[groupId] = {
        loader: isScoreLoading,
        response: score?.response_id,
        metrics: {
          visibility: score?.value,
          sentiment: score?.sentiment_score,
          ranking: score?.position,
        },
      };
    }

    rows.push(row);
  }

  return rows;
}

